
import { Result } from '@empathy/search-types';
import { VNodeData } from 'vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';
import { ResultConfig, TrackClickEvents } from '../../models';
import { DynamicTemplateMixin } from '../mixins/dynamic-render.mixin';

const DefaultResultTrackingClickEvents: TrackClickEvents = {
  click: EVENTS.ResultClicked,
  rightClick: EVENTS.ResultRightClicked
};

@Component
export default class ConfigurableResult extends Mixins(DynamicTemplateMixin) {
  // Object & Arrays prop defaults must be returned from a function https://vuejs.org/v2/guide/components-props.html
  @Prop({ default: () => DefaultResultTrackingClickEvents })
  clickEvents: TrackClickEvents;

  @Prop({ required: true })
  item: Result;

  @Prop({ required: true })
  resultConfig: ResultConfig;

  render() {
    const componentsConfig = this.item.type ? this.resultConfig[this.item.type] : this.resultConfig.default;
    return this.renderComponents(componentsConfig, this.bindProps)[0];
  }

  protected bindProps(data: VNodeData) {
    const { resultConfig, ...otherProps } = this.$props;
    if (!data.props) {
      data.props = {};
    }
    Object.assign(data.props, otherProps || {}, this.$attrs || {});
    return data;
  }
}
